export const privacyPolicyData = [
  {
    title: '',
    content: `At Kesari Tours, We take your privacy seriously and are committed to protecting your personal information. This Privacy Policy explains what personal information we collect from you, how we use it, and with whom we may share it. It also explains your rights and choices regarding your personal information, and how you can contact us with any questions or concerns.`
  },
  {
    title: 'Information We Collect',
    content: `We collect personal information from you when you use our website, such as your name, email address, and other contact information. We may also collect other information, such as your IP address, browsing history, and information about your device.`
  },
  {
    title: 'Third-Party Tracking and Analytics ',
    content: `Our website uses third-party tools to collect and analyze data about visitor behavior, enhance user experience, and optimize our marketing efforts. These tools may use cookies or similar technologies to track user interactions on our website.`
  },
  {
    title: '1.1 Google Analytics',
    content: `We use Google Analytics to collect information about website usage, including:
• Device and browser details
• IP address (anonymized for EU users)
• Pages visited, time spent on the website
• Referral sources (e.g., search engine, social media, direct visit)

Compliance Notes:
• <strong>GDPR</strong>: Requires user consent before collecting data. We obtain consent via a cookie banner for EU users.
• <strong>CCPA</strong>: Users can opt out of data collection by using the <a target="_blank" href="https://tools.google.com/dlpage/gaoptout">Google Analytics Opt-Out Add-on.</a> 
• <strong>DPDPA</strong>: Users must be informed of data collection practices.

For more details, see  <a target="_blank" href="https://policies.google.com/privacy">Google’s Privacy Policy.</a>`
  },
  {
    title: '1.2 Google Tag Manager',
    content: `We use Google Tag Manager to manage marketing and analytics tools.
While Google Tag Manager does not collect personal data, the tags it manages may collect user data.
See Google’s Privacy Policy.`
  },
  {
    title: '1.3 Facebook Pixel',
    content: `We use Facebook Pixel for targeted advertising and to measure ad performance. Facebook may collect:\n
• IP addresses\n
• Browser/device details\n
• User activity on our website\n\n
Users can manage ad preferences via <a target="_blank" href="https://accountscenter.facebook.com/ads/">Facebook Ad Settings.</a>.`
  },
  {
    title: '2. Compliance with Data Protection Laws',
    content: ``
  },
  {
    title: '2.1 General Data Protection Regulation (GDPR) – For EU Users',
    content: `Under GDPR, we process data based on:\n
  • <strong>Consent</strong> – Explicit consent is required before collecting personal data.\n
  • <strong>Legitimate interest</strong> – For essential website functions and security.\n\n`
  },
  {
    title: 'EU User Rights under GDPR',
    content: `
  • Right to access, correct, delete personal data.<br/>
  • Right to object to data processing.<br/>
  • Right to withdraw consent at any time.<br/><br/>
  To exercise your rights, contact us at <a href="mailto:inbound@kesari.in">inbound@kesari.in</a>.`
  },
  {
    title: '2.2 California Consumer Privacy Act (CCPA) – For US Users',
    content: `California residents have the right to:\n
  • <strong>Know </strong> what personal data we collect and how we use it.\n
  • <strong>Delete</strong> their personal data upon request.\n
  • <strong>Opt out</strong> of data sales/sharing for advertising.\n\n
  To request data access or deletion, contact us at  <a href="mailto:inbound@kesari.in">inbound@kesari.in</a>.`
  },
  {
    title: '2.3 Digital Personal Data Protection Act (DPDPA) – For Indian Users',
    content: `• Data is processed only with <strong> explicit consent </strong >, except where necessary for legal purposes.\n
  • Users have the right to request <strong>data access, correction, and deletion.</strong>\n\n
  For more details, refer to India’s <a target="_blank" href="https://www.meity.gov.in/">Digital Personal Data Protection Act.</a>`
  },
  {
    title: '3. Managing Cookies & Tracking Technologies',
    content: `Users can manage or disable cookies by:\n
  • Adjusting browser settings to block or delete cookies.\n
  • Using the  <a target="_blank" href="https://www.youronlinechoices.com/">Your Online Choices tool</a> (for EU users).\n
  • Using the <a target="_blank" href="https://optout.networkadvertising.org/?c=1">Network Advertising Initiative Opt-Out </a>(for US users).\n\n
  By continuing to use our website, you agree to the use of these tracking tools as described in this policy.`
  },
  {
    title: 'How We Use Your Information',
    content: `We use your personal information to provide you with the services and information you request, to improve our website and services, and to communicate with you. We may also use your information for research, analytics, and marketing purposes.`
  },
  {
    title: 'Sharing Your Information',
    content: `We will not share your personal information with any third parties except as described in this Privacy Policy or as required by law. For example, we may share your information with service providers who assist us with providing our services or with authorities if we are required by law to do so.`
  },
  {
    title: 'Your Rights and Choices',
    content: `You have the right to access and update your personal information, and to request that we delete it. You also have the right to opt-out of receiving communications from us. You can exercise these rights by contacting us using the contact information provided below.`
  },
  {
    title: 'Data Storage & Security',
    content: `We are committed to protecting your personal information from unauthorized access or use. We use a combination of technical and organizational measures to protect your personal information, including encryption and secure servers.`
  },
  {
    title: 'Compliance with Laws and Regulations',
    content: `We comply with all relevant laws and regulations, including the General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA).`
  },
  {
    title: 'Contact Us',
    content: `If you have any questions or concerns about this Privacy Policy or our use of your personal information, please contact us by email at <span style="font-weight:bold; color:#27306B; cursor:pointer">inbound@kesari.in</span> or by phone at <span style="font-weight:bold; color:#1976d2;">+91 9920305678</span>.`
  },
  {
    title: 'Changes to Our Privacy Policy',
    content: `We may update this Privacy Policy from time to time. We will notify you of any changes by posting the updated Privacy Policy on our website. By using our website and services, you agree to this Privacy Policy and our use of your personal information as described herein. This privacy policy was last updated on 2nd April 2025.`
  }
];

export default privacyPolicyData;
